export enum WiseOwlAppRealm {
  local = "local",
  dev = "dev",
  stage = "stage",
  prod = "prod",
}

export enum WiseOwlAppHostname {
  prod = "wiseowl.twilio.com",
  stage = "wiseowl.stage.twilio.com",
  dev = "wiseowl.dev.twilio.com",
  local = "localhost",
}
